import React, { useState } from "react";
import WaveXchangeIcon from "../../../assets/images/wavexchange-small-icon.svg";

interface NENodeFooterProps {
  selectedNe: any;
}

const NENodeFooter: React.FC<NENodeFooterProps> = ({ selectedNe }) => {
  const [isDragging, setIsDragging] = useState(false);
  let dragTimeout: NodeJS.Timeout;

  const handleDragStart = () => {
    setIsDragging(true);
  };
  const handleDragEnd = () => {
    if (isDragging) {
      if (dragTimeout) {
        clearTimeout(dragTimeout);
      }
    }
    dragTimeout = setTimeout(() => {
      const event = new CustomEvent("nodeDragComplete", {
        detail: { nodeId: selectedNe.ne_name },
      });
      window.dispatchEvent(event);
      setIsDragging(false);
    }, 10);
  };

  const content = (
    <div
      className="node-footer"
      onMouseDown={handleDragStart}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd}
      onMouseOver={handleDragEnd}
    >
      <div>
        <span>
          {selectedNe.city ? `${selectedNe.city}, ` : ""}
          {selectedNe.state ? selectedNe.state : ""}
        </span>{" "}
      </div>
    </div>
  );
  return content;
};

export default NENodeFooter;
